(function () {
  window.dataLayer = window.dataLayer || [];

  const parseFloatSafe = (value) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  };

  const parseIntSafe = (value, fallback = 1) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const pushEvent = (eventName, params = {}) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ...params,
    });
  };

  const readItemFromDataset = (dataset) => {
    const item = {
      item_id: dataset.ga4ItemId,
      item_name: dataset.ga4ItemName,
      item_brand: dataset.ga4ItemBrand,
      item_category: dataset.ga4ItemCategory,
      currency: dataset.ga4Currency,
    };

    const price = parseFloatSafe(dataset.ga4ItemPrice);
    if (typeof price !== "undefined") item.price = price;

    const index = parseIntSafe(dataset.ga4ItemIndex, 0);
    if (index > 0) item.index = index;

    return item;
  };

  const setupProductListTracking = () => {
    const trackedLinks = document.querySelectorAll("[data-ga4-item-link]");

    trackedLinks.forEach((link) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || link.dataset.ga4Seen === "true") return;

            link.dataset.ga4Seen = "true";
            const item = readItemFromDataset(link.dataset);
            const listName = link.dataset.ga4ListName || "catalog";

            pushEvent("view_item_list", {
              ecommerce: {
                item_list_name: listName,
                items: [item],
              },
            });
          });
        },
        { threshold: 0.5 },
      );

      observer.observe(link);
    });

    document.addEventListener("click", (event) => {
      const link = event.target.closest("[data-ga4-item-link]");
      if (!link) return;

      const item = readItemFromDataset(link.dataset);
      const listName = link.dataset.ga4ListName || "catalog";

      pushEvent("select_item", {
        ecommerce: {
          item_list_name: listName,
          items: [item],
        },
      });
    });
  };

  const trackViewItem = () => {
    const viewItemEl = document.querySelector("[data-ga4-view-item]");
    if (!viewItemEl || viewItemEl.dataset.ga4Tracked === "true") return;

    viewItemEl.dataset.ga4Tracked = "true";
    const item = readItemFromDataset(viewItemEl.dataset);

    pushEvent("view_item", {
      ecommerce: {
        currency: item.currency,
        value: item.price,
        items: [item],
      },
    });
  };

  const trackAddToCart = (item, quantity = 1) => {
    const normalizedItem = { ...item };
    normalizedItem.quantity = parseIntSafe(quantity, 1);

    const value =
      typeof normalizedItem.price === "number"
        ? Number((normalizedItem.price * normalizedItem.quantity).toFixed(2))
        : undefined;

    pushEvent("add_to_cart", {
      ecommerce: {
        currency: normalizedItem.currency,
        value,
        items: [normalizedItem],
      },
    });
  };

  const trackRemoveFromCart = (item) => {
    const normalizedItem = { ...item };
    normalizedItem.quantity = parseIntSafe(normalizedItem.quantity, 1);

    const value =
      typeof normalizedItem.price === "number"
        ? Number((normalizedItem.price * normalizedItem.quantity).toFixed(2))
        : undefined;

    pushEvent("remove_from_cart", {
      ecommerce: {
        currency: normalizedItem.currency,
        value,
        items: [normalizedItem],
      },
    });
  };

  const setupAuthAndLeadEvents = () => {
    if (!document.body.classList.contains("template-customers-account")) return;

    if (sessionStorage.getItem("nars_ga4_login_attempt") === "1") {
      pushEvent("login");
      sessionStorage.removeItem("nars_ga4_login_attempt");
    }

    if (sessionStorage.getItem("nars_ga4_signup_attempt") === "1") {
      pushEvent("sign_up");
      sessionStorage.removeItem("nars_ga4_signup_attempt");
    }
  };

  window.NarsGA4 = {
    pushEvent,
    trackAddToCart,
    trackRemoveFromCart,
  };

  document.addEventListener("DOMContentLoaded", () => {
    setupProductListTracking();
    trackViewItem();
    setupAuthAndLeadEvents();
  });
})();
